import axiosClient from "./axiosClients";

const uri = "/categoryParents";

class CategoryParentApi {
  getAll = () => {
    return axiosClient.get(uri);
  };
}
const categoryParentApi = new CategoryParentApi();
export default categoryParentApi;
